import React from "react";
import "./IconButton.css";

const IconButton = ({ onClick, icon, iconElement,  alt = "icon", size = 20 }) => {
  return (
    <button className="icon-button" onClick={onClick}>
      {icon ? (
        <img src={icon} alt={alt} className="button-icon" style={{ width: size, height: size }} />
      ) : iconElement ? (
          React.createElement(iconElement, { style: { width: size, height: size } })
        )
       : null}
    </button>
  );
};

export default IconButton;